// frontend/src/components/purchase/TimeWindowSelector.jsx
// Allows users to select group window (how long to wait for group to grow)
// Simplified - no prices shown here, focuses on timing only

import React from 'react';
import { Clock, Zap, Truck, Calendar } from 'lucide-react';

const TIME_WINDOW_CONFIG = {
  EXPRESS: {
    label: 'Express',
    description: 'Ships today',
    icon: Zap,
    color: 'text-orange-500',
    bgColor: 'bg-orange-50',
    borderColor: 'border-orange-200',
    selectedBg: 'bg-orange-100',
  },
  ONE_DAY: {
    label: '1 Day',
    description: 'Ships tomorrow',
    icon: Clock,
    color: 'text-blue-500',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    selectedBg: 'bg-blue-100',
  },
  THREE_DAY: {
    label: '3 Days',
    description: 'Ships in 3 days',
    icon: Truck,
    color: 'text-green-500',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-200',
    selectedBg: 'bg-green-100',
  },
  SEVEN_DAY: {
    label: '7 Days',
    description: 'Ships in 7 days',
    icon: Calendar,
    color: 'text-purple-500',
    bgColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
    selectedBg: 'bg-purple-100',
  }
};

const TimeWindowSelector = ({ 
  selected = 'THREE_DAY', 
  onSelect
}) => {
  const windows = ['EXPRESS', 'ONE_DAY', 'THREE_DAY', 'SEVEN_DAY'];
  
  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Delivery Window
      </label>
      
      <div className="grid grid-cols-4 gap-2">
        {windows.map((window) => {
          const config = TIME_WINDOW_CONFIG[window];
          const isSelected = selected === window;
          const Icon = config.icon;
          
          return (
            <button
              key={window}
              type="button"
              onClick={() => onSelect(window)}
              className={`
                relative flex flex-col items-center p-3 rounded-lg border-2 transition-all
                ${isSelected 
                  ? `${config.selectedBg} ${config.borderColor}`
                  : `bg-white border-gray-200 hover:${config.bgColor}`
                }
              `}
            >
              {/* Popular Badge */}
              {window === 'THREE_DAY' && (
                <span className="absolute -top-2 left-1/2 -translate-x-1/2 px-2 py-0.5 text-xs font-medium bg-green-500 text-white rounded-full whitespace-nowrap">
                  Popular
                </span>
              )}
              
              {/* Icon */}
              <Icon className={`w-5 h-5 ${isSelected ? config.color : 'text-gray-400'} mb-1`} />
              
              {/* Label */}
              <span className={`font-medium text-sm ${isSelected ? 'text-gray-900' : 'text-gray-600'}`}>
                {config.label}
              </span>
              
              {/* Description */}
              <span className="text-xs text-gray-500 text-center">
                {config.description}
              </span>
            </button>
          );
        })}
      </div>
      
      {/* Explanation Text */}
      <p className="text-xs text-gray-500 text-center mt-2">
        💡 Longer windows = more time to share & unlock bigger savings
      </p>
    </div>
  );
};

export default TimeWindowSelector;